/**
 * StatLine — cartouche de statistiques gravé (audit D5, ADR 0015).
 *
 * Remplace les boîtes KPI identiques par UNE ligne typographique
 * « gravée » (`--press`) : `3/7 planifiés · 6 articles · 4 jours
 * restants`. Règles :
 *
 *   - l'appelant ne passe QUE les parties non nulles (les métriques à
 *     zéro disparaissent au lieu d'afficher « 0 ») ;
 *   - aucune partie → rien n'est rendu (pas de cartouche vide) ;
 *   - séparateur point médian, chiffres en DM Serif via CSS.
 */
import { html, nothing, type TemplateResult } from 'lit-html';
import styles from './editorial.module.css';

export interface StatLineProps {
  /** Parties déjà formatées, sans les zéros. */
  parts: readonly string[];
  testid?: string;
}

export function statLine(props: StatLineProps): TemplateResult | typeof nothing {
  const parts = props.parts.filter((p) => p.trim().length > 0);
  if (parts.length === 0) return nothing;
  return html`<div class=${styles.statLine} data-testid=${props.testid ?? 'stat-line'}>
    ${parts.map(
      (p, i) =>
        html`${i > 0
            ? html`<span class=${styles.statLineSep} aria-hidden="true">·</span>`
            : nothing}<span class=${styles.statLinePart}>${p}</span>`,
    )}
  </div>`;
}
